import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { BackendAPIService } from '../../core/backend-api.service';
import {
  SatelliteOtherDetails,
  SatelliteSurveillance
} from '../../modules/admin/admin-satellite/surveillance/admin-satellite-surveillance.model';

@Injectable({
  providedIn: 'root'
})

export class AdminSatelliteService {

  constructor(private backendAPIService: BackendAPIService,
              private httpClient: HttpClient
              // private userDevicesActions: UserDevicesActions
  ) {
  }

  getSatelliteSurveillance(): Observable<any> {
    return this.httpClient
      .get<{satellites: Array<SatelliteSurveillance>}>('servlets/satellites/', {observe: 'body'});
  }

  getSatelliteOtherDetails(satelliteId, user): Observable<any> {
    return this.httpClient
      .get<{otherDetails: SatelliteOtherDetails}>(`servlets/satellites/datasources/${satelliteId}/${user}/`,
        {observe: 'body'});
  }

  getConnectionProfiles(): Observable<any> {
      return this.httpClient
          .get('servlets/satellites/connectionprofiles/', {observe: 'body'});
  }

  updateConnectionProfiles(userName, connectionProfileId): Observable<any> {
      return this.httpClient
          .put('servlets/satellites/connectionprofiles/', {userName, connectionProfileId});
  }
}
